"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PICTORIAL_ICONS = exports.PictorialIconName = void 0;
var PictorialIconName;
(function (PictorialIconName) {
    PictorialIconName["AbstractConvention"] = "abstract-convention";
    PictorialIconName["AbstractDigitizeEverywhere"] = "abstract-digitize-everywhere";
    PictorialIconName["AbstractDynamicRange"] = "abstract-dynamic-range";
    PictorialIconName["AbstractFearlessly"] = "abstract-fearlessly";
    PictorialIconName["AbstractLearning"] = "abstract-learning";
    PictorialIconName["AbstractOwners"] = "abstract-owners";
    PictorialIconName["AbstractParallel"] = "abstract-parallel";
    PictorialIconName["AbstractPastPossible"] = "abstract-past-possible";
    PictorialIconName["AbstractPlatform"] = "abstract-platform";
    PictorialIconName["AbstractRisk"] = "abstract-risk";
    PictorialIconName["AbstractUrgency"] = "abstract-urgency";
    PictorialIconName["AbstractViscosity"] = "abstract-viscosity";
    PictorialIconName["BusinessAward"] = "business-award";
    PictorialIconName["BusinessBuilding"] = "business-building";
    PictorialIconName["BusinessPresentation"] = "business-presentation";
    PictorialIconName["BusinessProgressBar"] = "business-progress-bar";
    PictorialIconName["BusinessPuzzlePieces"] = "business-puzzle-pieces";
    PictorialIconName["BusinessRealEstate"] = "business-real-estate";
    PictorialIconName["BusinessShopping"] = "business-shopping";
    PictorialIconName["BusinessBarGraph"] = "business-bar-graph";
    PictorialIconName["BusinessBook"] = "business-book";
    PictorialIconName["BusinessCalendar"] = "business-calendar";
    PictorialIconName["BusinessCertificate"] = "business-certificate";
    PictorialIconName["BusinessNametag"] = "business-nametag";
    PictorialIconName["BusinessNetwork"] = "business-network";
    PictorialIconName["BusinessNotebook"] = "business-notebook";
    PictorialIconName["BusinessNotebooks"] = "business-notebooks";
    PictorialIconName["BusinessPaper"] = "business-paper";
    PictorialIconName["BusinessPersonalChart"] = "business-personal-chart";
    PictorialIconName["BusinessPieChart"] = "business-pie-chart";
    PictorialIconName["BusinessPresentationGraph"] = "business-presentation-graph";
    PictorialIconName["HealthcareBandaid"] = "healthcare-bandaid";
    PictorialIconName["HealthcareHealthReport"] = "healthcare-health-report";
    PictorialIconName["HealthcareHospital"] = "healthcare-hospital";
    PictorialIconName["HealthcarePills"] = "healthcare-pills";
    PictorialIconName["HealthcareStethoscope"] = "healthcare-stethoscope";
    PictorialIconName["HealthcareVaccine"] = "healthcare-vaccine";
    PictorialIconName["HealthcareWheelchair"] = "healthcare-wheelchair";
    PictorialIconName["HealthcareCancerRibbon"] = "healthcare-cancer-ribbon";
    PictorialIconName["HealthcareHealth"] = "healthcare-health";
    PictorialIconName["HumanityCompass"] = "humanity-compass";
    PictorialIconName["HumanityGreen"] = "humanity-green";
    PictorialIconName["HumanityLightbulb"] = "humanity-lightbulb";
    PictorialIconName["HumanityLocation"] = "humanity-location";
    PictorialIconName["HumanityPersonalChart"] = "humanity-personal-chart";
    PictorialIconName["HumanityProfile"] = "humanity-profile";
    PictorialIconName["HumanitySpeechBubbles"] = "humanity-speech-bubbles";
    PictorialIconName["HumanityWorld"] = "humanity-world";
    PictorialIconName["HumanityGlobe"] = "humanity-globe";
    PictorialIconName["HumanityGear"] = "humanity-gear";
    PictorialIconName["ScienceFlaskBubbling"] = "science-flask-bubbling";
    PictorialIconName["ScienceGerm"] = "science-germ";
    PictorialIconName["ScienceMicroscope"] = "science-microscope";
    PictorialIconName["ScienceMoleculesClean"] = "science-molecules-clean";
    PictorialIconName["ScienceMRNA"] = "science-mrna";
    PictorialIconName["ScienceProtected"] = "science-protected";
    PictorialIconName["ScienceStudying"] = "science-studying";
    PictorialIconName["ScienceBeaker"] = "science-beaker";
    PictorialIconName["ScienceChart"] = "science-chart";
    PictorialIconName["ScienceFlask"] = "science-flask";
    PictorialIconName["ScienceMagnifyingGlass"] = "science-magnifying-glass";
    PictorialIconName["ScienceMoleculesScattered"] = "science-molecules-scattered";
    PictorialIconName["SciencePetriDish"] = "science-petri-dish";
    PictorialIconName["SciencePresentation"] = "science-presentation";
    PictorialIconName["ScienceAtoms"] = "science-atoms";
    PictorialIconName["ScienceCells"] = "science-cells";
    PictorialIconName["ScienceClipboard"] = "science-clipboard";
    PictorialIconName["ScienceDNA"] = "science-dna";
    PictorialIconName["ScienceMoleculesCentered"] = "science-molecules-centered";
    PictorialIconName["ScienceMRNA2"] = "science-mrna-2";
    PictorialIconName["ScienceTestTube"] = "science-test-tube";
})(PictorialIconName || (exports.PictorialIconName = PictorialIconName = {}));
exports.PICTORIAL_ICONS = Object.values(PictorialIconName).reduce((res, val) => {
    res[val] = true;
    return res;
}, 
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
{});
//# sourceMappingURL=PictorialIconConsts.js.map